import { render, staticRenderFns } from "./ride-card-list.vue?vue&type=template&id=683a323b&scoped=true&lang=pug&"
import script from "./ride-card-list.vue?vue&type=script&lang=js&"
export * from "./ride-card-list.vue?vue&type=script&lang=js&"
import style0 from "./ride-card-list.vue?vue&type=style&index=0&id=683a323b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a323b",
  null
  
)

export default component.exports